// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__EuV0m","buttons":"styles_buttons__2Qgul"};